import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgNzPost = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 32,
	height: 32,
	viewBox: "0 0 40 40",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("rect", {
		width: 40,
		height: 40,
		rx: 20,
		fill: "#D8291C"
	}), /* @__PURE__ */ _jsx("path", {
		fill: "#fff",
		fillRule: "nonzero",
		d: "M11.334 23.609v14.415c-.796-.383-1.565-.819-2.303-1.304V23.958c0-.79.091-1.566.531-2.232.496-.756 1.28-1.188 2.363-1.188 1.41 0 2.286.756 3.527 3.035 2.336 4.282 5.406 5.811 8.666 5.811 5.439 0 9.604-4.254 9.604-9.354a9.35 9.35 0 0 0-2.832-6.759 9.3 9.3 0 0 0-2.268-1.614 9.5 9.5 0 0 0-2.618-.88c-1.028-.192-2.1-.226-3.443-.226H2.372c.423-.787.898-1.545 1.422-2.268h18.764c1.456 0 2.63.045 3.894.27a12.4 12.4 0 0 1 3.227 1.073 11.6 11.6 0 0 1 2.832 2.031A11.4 11.4 0 0 1 39.015 20c0 6.353-5.191 11.612-11.916 11.612-4.763 0-8.351-2.641-10.766-7.357-.586-1.151-.793-1.513-1.302-1.513-.378 0-.697.287-.697.815zm-2.991-2.879c.779-1.14 2.036-1.76 3.593-1.76 1.456 0 2.975.542 4.611 3.452 2.302 4.085 4.638 5.406 7.515 5.406 4.694 0 8.092-3.521 8.091-7.809a7.32 7.32 0 0 0-2.37-5.653 7.2 7.2 0 0 0-1.873-1.309 7.7 7.7 0 0 0-2.202-.734c-.903-.169-1.76-.192-3.149-.192H2.609a20 20 0 0 0-.809 2.257h21.92c1.223 0 1.985.034 2.64.158.543.096 1.068.275 1.557.531.489.257.937.583 1.331.97a5.54 5.54 0 0 1 1.614 3.927c0 3.07-2.415 5.574-5.619 5.574-2.877 0-4.48-2.008-5.75-4.243-1.835-3.216-3.78-4.604-6.5-4.604-2.202 0-4.21.914-5.473 2.651-1.32 1.818-1.32 3.894-1.32 4.605v9.487a21 21 0 0 0 2.302 2.163V24.002c0-.59 0-2.043.84-3.272z"
	})]
});
export default SvgNzPost;
